import { pushService } from "@/services/PushService";
import { i18n } from "@/utils/i18n";
import { Toast } from "./toast";

/**
 * PushPrompt —— 软提示引导组件逻辑
 */
export class PushPrompt {
  private static STORAGE_KEY = "push_prompt_dismissed_at";
  private static DISMISS_DURATION = 1000 * 60 * 60 * 24 * 7; // 7 天后可再次提示

  static compiler() {
    // 处理引导弹窗
    up.compiler("[data-push-prompt]", async (el: HTMLElement) => {
      const optInBtn = el.querySelector("[data-push-prompt-optin]");
      const closeBtns = el.querySelectorAll("[data-push-prompt-close]");

      // 初始化：延迟检查是否显示
      setTimeout(async () => {
        const shouldShow = await PushPrompt.checkConditions();
        if (shouldShow) {
          el.classList.remove("hidden");
          el.classList.add("reveal-content");
        }
      }, 5000);

      optInBtn?.addEventListener("click", async () => {
        const state = await pushService.getSubscriptionState();
        if (state.permission === "denied") {
          Toast.warning(i18n.t("push.prompt.denied"));
          return;
        }

        const success = await pushService.optIn();
        if (success) {
          el.classList.add("hidden");
        }
      });

      closeBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          el.classList.add("hidden");
          localStorage.setItem(PushPrompt.STORAGE_KEY, Date.now().toString());
        });
      });
    });

    // 处理独立的订阅按钮（如文章末尾的卡片）
    up.compiler(
      "[data-push-prompt-optin]:not([data-push-prompt] *)",
      (el: HTMLElement) => {
        el.addEventListener("click", async () => {
          const state = await pushService.getSubscriptionState();
          if (state.permission === "denied") {
            Toast.warning(i18n.t("push.prompt.denied"));
            return;
          }

          const success = await pushService.optIn();
          if (success) {
            // 可选：显示成功状态
            el.textContent = i18n.t("common.subscribed");
            el.classList.add("opacity-50", "pointer-events-none");
          }
        });
      },
    );
  }

  private static async checkConditions(): Promise<boolean> {
    // 1. 检查订阅状态
    const state = await pushService.getSubscriptionState();
    if (!state.canPrompt) return false;

    // 2. 检查本地冷却时间
    const dismissedAt = localStorage.getItem(PushPrompt.STORAGE_KEY);
    if (dismissedAt) {
      const now = Date.now();
      if (now - parseInt(dismissedAt, 10) < PushPrompt.DISMISS_DURATION) {
        return false;
      }
    }

    return true;
  }
}
